import React from 'react';
import { AuthorLink } from './index';
import classNames from 'classnames';

const LabelName = ({ className = '', label, names }) => (
  <div className={classNames(['label-name-underline', className])}>
    <div className="label-name-underline__label">{label}</div>
    <div className="label-name-underline__name">
      {names.map((author, idx) => (
        <AuthorLink author={author} postAuthors={names} index={idx} key={idx} />
      ))}
    </div>
  </div>
);

export default LabelName;
